import { colours } from "@pp/lib/ui/theme";
import React from "react";

const labelCols = [
  colours.greys.grey0,
  colours.greys.grey0,
  colours.ppForest,
  colours.ppForest,
  colours.greys.grey0,
];

const mapAgreeColours : (x:number) => string = x=>{
  switch (x) {
    case 1: return "stronglyDisagree"
    case 2: return "disagree"
    case 3: return "neutral"
    case 4 : return "agree"
    case 5 : return "stronglyAgree"
  
    default:
      break;
  }
}

export const StackedBar = ({ data }) => {
  
  return (
    <div
      style={{
        display: "flex",
        maxWidth: "550px",
        height: "30px",
        borderRadius: "5px",
        overflow: "hidden",
        border: "1px solid #ddd",
        marginLeft: "4px",
      }}
    >
      {data.sort((a,b)=>a.SortOrder - b.SortOrder).map((x: any, index) => {
        return (
          <div
            key={index}
            style={{
              width: `${x.Percentage}%`,
              backgroundColor: colours.agreeColours[mapAgreeColours(x.SortOrder)],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: labelCols[x.SortOrder - 1],
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {`${Math.round(x.Percentage)}%`}
          </div>
        );
      })}
    </div>
  );
};

export const ProgressBar = ({ percentage, style = {} }) => (
  <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
    <div
      style={{
        width: "50%",
        height: "10px",
        backgroundColor: "#e0e0e0",
        borderRadius: "5px",
        display: "flex",
        ...style,
      }}
    >
      <div
        style={{
          height: "10px",
          width: `${percentage}%`,
          backgroundColor: "#0d3b66",
          borderRadius: "5px",
        }}
      />
    </div>
    <span>{Math.round(percentage)}%</span>
  </div>
);
